import { Grid, Typography, styled } from '@mui/material'

export const Wrapper = styled(Grid)(({ theme }) => ({
  width: 'auto',
}))

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: '2.25rem',
  lineHeight: '2.625rem',

  [theme.breakpoints.down('md')]: {
    fontSize: '1.5rem',
    lineHeight: '1.75rem',
  },
}))

export const Subtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],

  [theme.breakpoints.down('md')]: {
    fontSize: '1.25rem',
    lineHeight: '1.5rem',
    marginBottom: theme.spacing(1),
  },
}))

export const ActionsContainer = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  gap: theme.spacing(1),
  display: 'flex',
  justifyContent: 'flex-end',
  marginBlock: 'auto',

  [theme.breakpoints.down('md')]: {
    justifyContent: 'flex-start',
  },
}))

export const Container = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(5),
  width: 'auto',

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    marginBottom: theme.spacing(2),
    gap: theme.spacing(2),
  },
}))
